import api from '../services/api';

const API_BASE = '/geographic';

export interface DensityData {
  region: string;
  state?: string;
  city?: string;
  carrier_count: number;
  active_carriers?: number;
}

export interface AddressCheckResult {
  exactMatches: { count: number; carriers: CarrierInfo[] };
  nearbyMatches: { count: number; carriers: CarrierInfo[] };
  searchCriteria: any;
}

export interface CarrierInfo {
  dot_number: number;
  legal_name: string;
  dba_name: string;
  phy_street: string;
  phy_city: string;
  phy_state: string;
  phy_zip: string;
  status_code: string;
  carrier_operation: string;
  total_drivers: number;
  power_units: number;
}

export interface SafetyStats {
  region: string;
  carrier_count: number;
  total_inspections: number;
  total_crashes: number;
  oos_inspections: number;
  avg_oos_rate: number;
  safety_score: number;
}

export const getCarrierDensity = async (level: string, state?: string, minCount?: number): Promise<DensityData[]> => {
  const params: any = { level };
  if (state) params.state = state;
  if (minCount) params.minCount = minCount;
  const { data } = await api.get(`${API_BASE}/density`, { params });
  return data.data || data;
};

export const checkAddress = async (params: { address?: string; city?: string; state?: string; zip?: string }): Promise<AddressCheckResult> => {
  const { data } = await api.get(`${API_BASE}/address-check`, { params });
  return data;
};

export const getSafetyStats = async (level: string, region?: string): Promise<SafetyStats[]> => {
  const params: any = { level };
  if (region) params.region = region;
  const { data } = await api.get(`${API_BASE}/safety-stats`, { params });
  return data.data || data;
};

export const getAddressNeighbors = async (zip: string) => {
  const { data } = await api.get(`${API_BASE}/address-neighbors`, { params: { zip } });
  return data.data || data;
};
